import React from "react";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import Chip from "@material-ui/core/Chip";

function TrendingBarList(props) {
  const { items, fqdn, toggleTrendingBarModal, setTrendingBarModalData, deleteTrendingBarItem } = props;

  const getFullUrl = (url) => {
    if (!url) return url;
    if (url.startsWith("http")) return url;
    return fqdn ? `https://${fqdn}${url.startsWith("/") ? "" : "/"}${url}` : url;
  };

  const handleDelete = (itemId) => {
    if (window.confirm("Are you sure you want to delete this trending bar item?")) {
      deleteTrendingBarItem(itemId);
    }
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} md={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              margin: "20px 0 20px",
              marginLeft: "4.5%",
            }}
          >
            <span
              style={{ display: "flex", color: "#fb4d24" }}
              onClick={() => toggleTrendingBarModal(true)}
            >
              <AddCircleIcon /> &nbsp;
              <span style={{ color: "#232323", paddingTop: "2px" }}>
                Add Trending Bar Item
              </span>
            </span>
          </div>
        </GridItem>

        <GridItem xs={12} sm={12} md={12}>
          {items && items.length > 0 ? (
            <Paper style={{ overflowX: "auto", margin: "0 4.5%" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold" }}>Order</TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>Label</TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>URL</TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
                    <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.sortOrder !== undefined ? item.sortOrder : item.sort_order}</TableCell>
                      <TableCell>{item.label}</TableCell>
                      <TableCell style={{ maxWidth: "350px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {getFullUrl(item.url)}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={(item.isActive !== undefined ? item.isActive : item.is_active) ? "Active" : "Inactive"}
                          style={{
                            backgroundColor: (item.isActive !== undefined ? item.isActive : item.is_active) ? "#24c32a" : "#8d8d8d",
                            color: "#fff",
                            fontSize: "12px",
                            height: "24px",
                          }}
                        />
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <IconButton
                          onClick={() => setTrendingBarModalData(item)}
                          style={{ color: "#fb4d24" }}
                          size="small"
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={() => handleDelete(item.id)}
                          style={{ color: "#e53935" }}
                          size="small"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          ) : (
            <div style={{ textAlign: "center", padding: "40px 0", color: "#8d8d8d" }}>
              <p>No trending bar items found. Click "Add Trending Bar Item" to create one.</p>
            </div>
          )}
        </GridItem>
      </GridContainer>
    </>
  );
}

export default TrendingBarList;
